import { render, staticRenderFns } from "./TimeSpentMainChart.vue?vue&type=template&id=b31ab4c2&scoped=true&"
import script from "./TimeSpentMainChart.vue?vue&type=script&lang=js&"
export * from "./TimeSpentMainChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31ab4c2",
  null
  
)

export default component.exports